import { GiftCardRedemptionComponentModule } from '@b2b/common/components/gift-card-redemption/gift-card-redemption.component';
import { PaymentProcessError } from '@b2b/common/directives/payment/types';
import { Notice, NoticeFactory } from '@b2b/common/factories/notice';
import { ThemesData } from '@b2b/common/resolvers';
import { safeApply } from '@b2b/common/rxjs';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { LocationService, LocationServiceModule } from '@b2b/common/services/address/location.service';
import { ApiService } from '@b2b/common/services/api/types';
import {
  CheckoutProcessService,
  CheckoutProcessServiceModule,
} from '@b2b/common/services/checkout/checkoutProcess.service';
import { OrderEditCoreData, OrderEditData, SecureOrderEditProps } from '@b2b/common/services/checkout/edit-order.types';
import { isACMECORSCheckoutError } from '@b2b/common/services/checkout/types';
import { PaymentService, PaymentServiceModule } from '@b2b/common/services/payment/payment.service';
import { PermissionsService } from '@b2b/common/services/permissions';
import { RedemptionService, RedemptionServiceModule } from '@b2b/common/services/redemption/redemption.service';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { getGiftCardRedemptionsTotal } from '@b2b/common/utils/gift-card';
import { ACMEResponse, TODO } from '@b2b/types/core';
import { GiftCardRedemption } from '@b2b/types/cart';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IPromise, IQService, ISCEService, IScope, ITimeoutService } from 'angular';

export const OrdersPaymentModule = angular
  .module('acme.view.application.orders.payment.controllers', [
    uiRouter,
    'angularUUID2',
    'acme.common.service.api',
    'acme.common.service.order',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.themesHelper',
    'acme.common.factory.notice',
    CheckoutProcessServiceModule,
    PaymentServiceModule,
    LocationServiceModule,
    AddressServiceModule,
    GiftCardRedemptionComponentModule,
    RedemptionServiceModule,
  ])

  .controller('OrdersPaymentController', [
    '$scope',
    '$q',
    '$sce',
    '$state',
    '$filter',
    '$timeout',
    'uuid2',
    'ApiService',
    'CalendarService',
    'OrderService',
    'PermissionsService',
    'ThemesHelperService',
    'NoticeFactory',
    'OrderData',
    'ThemesData',
    'CheckoutProcessService',
    'PaymentService',
    'LocationService',
    'AddressService',
    'RedemptionService',
    function (
      $scope: IScope & { ordersPayment: TODO },
      $q: IQService,
      $sce: ISCEService,
      $state: StateService,
      $filter: IFilterService,
      $timeout: ITimeoutService,
      uuid2: TODO,
      ApiService: ApiService,
      CalendarService: TODO,
      OrderService: TODO,
      PermissionsService: PermissionsService,
      ThemesHelperService: ThemesHelperService,
      NoticeFactory: NoticeFactory,
      OrderData: TODO,
      ThemesData: { data: ACMEResponse<ThemesData> },
      CheckoutProcessService: CheckoutProcessService,
      paymentService: PaymentService,
      LocationService: LocationService,
      addressService: AddressService,
      RedemptionService: RedemptionService
    ) {
      const ctrl = {
        model: {} as TODO,
        notes: '',
        isSaving: false,
        isSubmitted: false,
        emailOption: false,
        paymentMethods: {
          0: 'CreditCard',
          1: 'Voucher',
          2: 'Check',
        },

        requiresCardData: false,

        requestUUID: false as string | false,

        themes: {},

        accountPaymentPolicy: {},

        isAccount: false,

        giftCardRedemptions: [] as GiftCardRedemption[],
        giftCardRedemptionsTotal: 0,
        amountDue: 0,

        getItemType: OrderService.getItemType,

        notice: {} as Notice,

        isEnabledCORSCheckout: false,

        orderDetails: {
          columns: 2,
          data: 'ordersPayment.model',
          include: [
            'orderNumber',
            'phoneNumber',
            'email',
            'legacy',
            'contactFirstName',
            'contactLastName',
            'checkInStatus',
          ],
          mappings: {
            legacy: 'Order Type',
          },
        },

        orderNotes: {
          columns: 1,
          data: 'ordersPayment.model',
          include: ['notes'],
          mappings: {
            notes: 'Order Notes',
          },
        },

        paymentDetails: {
          columns: 1,
          data: 'ordersPayment.model',
          include: [
            'saleChannel',
            'paymentMethodName',
            'ccLastFourDigits',
            'creditCardBrand',
            'paymentId',
            'refundStatus',
          ],
          mappings: {
            paymentId: 'Voucher Number',
            paymentMethodName: 'Payment Method',
            ccLastFourDigits: 'Card Last 4 Digits',
          },
        },

        accountDetails: {
          columns: 1,
          data: 'ordersPayment.model',
          include: ['accountName', 'companyName'],
        },

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Pay Order Balance',
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                ctrl.cancel();
              },
            },
            buttonRight: {
              label: 'Process Payment',
              action: function () {
                ctrl.processPayment();
              },
            },
          });

          paymentService.processData$
            .pipe(
              safeApply($scope, {
                next: ({ chargeAmount, paymentMethod }) => {
                  ctrl.requiresCardData = paymentMethod === 'CreditCard' && chargeAmount > 0;
                },
              })
            )
            .subscribe();

          this.notice = new NoticeFactory();

          if (OrderData && OrderData.data.success) {
            this.success.init(OrderData);
          } else {
            this.error.init(OrderData);
          }

          ThemesHelperService.resetModel();

          if (ThemesData && ThemesData.data.success) {
            this.initThemes(ThemesData);
          }

          $scope.$on('Payment::Complete', this.onPaymentComplete);
          $scope.$on('Payment::Error', this.onPaymentError);
        },

        initThemes: function (response) {
          var self = ctrl;
          ThemesHelperService.setModel(response.data.payload);
          self.themes = {
            policyTerms: $sce.trustAsHtml(ThemesHelperService.getHTMLVariable('checkout-process-page-terms')),
          };

          CheckoutProcessService.initACMECheckout();
          ctrl.isEnabledCORSCheckout = CheckoutProcessService.isEnabledCORSCheckout();
        },

        resetModel: function () {
          this.model.notes = '';
          this.model.orderId = 0;
          this.model.orderItems = [];
          this.model.noEmail = false;
          this.model.payment = {};
        },

        getPayment: function (accountId) {
          ApiService.partners.payments.account(accountId).then(ctrl.success.getPayment).catch(ctrl.error.getPayment);
        },

        selectEmailOption: function () {
          if (this.model.noEmail) {
            this.emailOption = 0;
          } else if (this.model.sendEmailToAll) {
            this.emailOption = 2;
          } else if (!this.model.noEmail && !this.model.sendEmailToAll) {
            this.emailOption = 1;
          }
        },

        setEmailOption: function () {
          switch (parseInt(this.emailOption, 10)) {
            case 0:
              this.model.noEmail = true;
              this.model.sendEmailToAll = false;
              break;
            case 1:
              this.model.noEmail = false;
              this.model.sendEmailToAll = false;
              break;
            case 2:
              this.model.noEmail = false;
              this.model.sendEmailToAll = true;
              break;
          }
        },

        process: function (order) {
          var i, ii;

          for (i = 0, ii = order.eventItems.length; i < ii; i++) {
            if (order.eventItems[i].eventDate) {
              order.eventItems[i].startDate = $filter('date')(
                CalendarService.parseDate(order.eventItems[i].eventDate),
                'M/d/yyyy'
              );
              order.eventItems[i].startHour = $filter('date')(
                CalendarService.parseDate(order.eventItems[i].eventDate),
                'h:mm a'
              );
            } else {
              order.eventItems[i].startDate = 'Date N/A';
              order.eventItems[i].startHour = 'Time N/A';
            }
          }

          return order;
        },

        processPayment: function () {
          this.isSubmitted = true;
          if (this.model.orderBalance > 0) {
            // Send message to payment directive to process order
            $scope.$broadcast('Payment::Process');
          } else {
            this.model.payment = null;
            this.complete();
          }
        },

        getBalanceDue: function () {
          return parseFloat(ctrl.model.orderBalance) || 0;
        },

        updateGiftCardAmountDue: function () {
          ctrl.giftCardRedemptionsTotal = getGiftCardRedemptionsTotal(ctrl.giftCardRedemptions);
          ctrl.amountDue = Math.max(0, ctrl.getBalanceDue() - ctrl.giftCardRedemptionsTotal);
        },

        onGiftCardRedemptionsChange: function (redemptions: GiftCardRedemption[]) {
          ctrl.giftCardRedemptions = redemptions;
          ctrl.updateGiftCardAmountDue();
        },

        /**
         * Redemptions already authorized against this order but not yet captured
         * (e.g. from an abandoned prior payment attempt) still hold funds against
         * the gift card, so they're loaded as if just applied in this session —
         * counted toward the balance due and removable like any other redemption.
         * Captured redemptions are already reflected in the order's balance, so
         * they're excluded here to avoid double-counting.
         */
        loadPendingGiftCardRedemptions: function (redemptions?: GiftCardRedemption[]) {
          ctrl.giftCardRedemptions = (redemptions || []).filter(
            (redemption) => redemption.status?.toUpperCase() === 'PENDING'
          );
        },

        /**
         * Voids any gift card redemptions still applied when the user backs out
         * of this screen. Nothing here has been saved to the order, so every
         * entry (whether a pre-existing pending hold loaded via
         * `loadPendingGiftCardRedemptions` or one applied during this session)
         * is an uncaptured authorization that would otherwise be left dangling
         * on the gift card.
         */
        voidGiftCardRedemptions: function (): IPromise<TODO> {
          const tenantId = String(ThemesHelperService.getCompany('tenantId') || '');
          const orderId = ctrl.model.orderId;

          return $q.all(
            ctrl.giftCardRedemptions.map((redemption) =>
              RedemptionService.api
                .remove({ tenantId, authorizationId: redemption.authorizationId, orderId })
                .catch(() => undefined)
            )
          );
        },

        /**
         * Checks for unsaved changes (used by the promptSave directive). The
         * only state that can go stale here is an applied gift card redemption
         * — it holds funds that would otherwise go uncaptured/unvoided if the
         * user navigates away silently.
         */
        checkDirty: function (): boolean {
          return ctrl.giftCardRedemptions.length > 0;
        },

        /**
         * Called when user clicks "Keep editing" in the discard changes modal.
         * Dismisses the modal and stays on the current page.
         */
        keepEditing: function () {
          return;
        },

        /**
         * Called when user clicks "Discard changes" in the modal.
         * Voids any applied gift card redemptions first, then continues
         * navigation without saving by broadcasting promptSave::Complete.
         */
        discardChanges: function () {
          ctrl.voidGiftCardRedemptions().finally(() => {
            $scope.$broadcast('promptSave::Complete');
          });
        },

        processACMEPaymentData: function (data: OrderEditData): SecureOrderEditProps {
          const address = addressService.createAddress(data.payment.address);
          const countryData = LocationService.findCountry({ country: address.country });
          const stateData = LocationService.findState({ state: address.state });
          const cssVarsData = CheckoutProcessService.getCORSCheckoutCSSVariables();

          return {
            values: data,
            options: {
              formattedBillingAddress: addressService.formatAddress({
                streetAddress1: address.streetAddress1,
                streetAddress2: address.streetAddress2,
                country: countryData ? countryData.country.name : address.country,
                zipCode: address.zipCode,
                city: address.city,
                state: stateData ? stateData.name : address.state,
              }),
              modal: {
                title: 'Payment',
                submit: 'Complete Order',
                close: 'Close',
              },
              authorizePayment: {
                paymentData: {
                  externalId: '',
                  chargeAmount: data.payment.chargeAmount ?? String(ctrl.getBalanceDue()),
                  firstName: data.billingFirstName || '',
                  lastName: data.billingLastName || '',
                  creditCardVerificationData: {
                    address1: address.streetAddress1,
                    address2: address.streetAddress2,
                    country: countryData ? String(countryData.country.numericCode) : address.country,
                    zipCode: address.zipCode,
                    city: address.city,
                    state: stateData ? stateData.abbreviation : address.state,
                  },
                },
                saleChannel: this.model.accountId ? 'reseller' : 'insideSalesIndividual',
              },
              capturePayment: {
                loaderHtml: CheckoutProcessService.getCheckoutLoadingHtml(),
              },
              autorenew: {
                enabled: false,
                html: ThemesHelperService.getTextVariable('checkout-process-page-autorenew-message'),
                url: '',
              },
              terms: {
                html: ThemesHelperService.getHTMLVariable('checkout-process-page-terms'),
                url: '',
              },
              creditCardSettings: {
                supportedCardsText: ThemesHelperService.getTextVariable('checkout-supported-cards-text'),
                showVisaLogo: ThemesHelperService.getTextVariable('checkout-show-visa-logo'),
                showMcLogo: ThemesHelperService.getTextVariable('checkout-show-mc-logo'),
                showDiscoverLogo: ThemesHelperService.getTextVariable('checkout-show-discover-logo'),
                showAmexLogo: ThemesHelperService.getTextVariable('checkout-show-amex-logo'),
              },
              variables: cssVarsData,
            },
          };
        },

        complete: function (paymentData) {
          const props = paymentData ? paymentData : ctrl.model;
          props.giftCardAuthorizationIds = ctrl.giftCardRedemptions.map((redemption) => redemption.authorizationId);
          this.notice.hideSuccessMessages();
          this.notice.hideErrorMessages();

          this.setEmailOption();

          if (!ctrl.requestUUID) {
            ctrl.requestUUID = uuid2.newuuid();
          }

          if (ctrl.shouldUseCORSCheckout()) {
            const data: OrderEditData = CheckoutProcessService.processOrderUpdateData(
              { ...props, requestUUID: ctrl.requestUUID },
              { withCreditCardInfo: false }
            );

            CheckoutProcessService.handleACMEPaymentSessionPayOrder(ctrl.processACMEPaymentData(data))
              .then((response) => ctrl.success.complete(response))
              .catch(async (response) => {
                if (isACMECORSCheckoutError(response)) {
                  switch (response.type) {
                    case 'sdk.render_failed': {
                      ctrl.clearLoading();

                      ctrl.error.complete({
                        status: 0,
                        data: { code: 0, errorCode: 0, error: response.params.message },
                      });
                      break;
                    }

                    case 'sdk.cancel_flow': {
                      ctrl.clearLoading();
                      break;
                    }

                    case 'sdk.billing_address.request_change': {
                      ctrl.clearLoading();
                      document.querySelector(`[data-testid="billing-address-anchor"]`)?.scrollIntoView();
                      break;
                    }

                    case 'api.error': {
                      ctrl.error.complete(CheckoutProcessService.mapToPaymentProcessError(response));
                      break;
                    }

                    default: {
                      console.warn(`unhandled`, response);

                      ctrl.clearLoading();
                      break;
                    }
                  }
                } else {
                  ctrl.error.complete(response);
                }
              });
          } else {
            const data: OrderEditCoreData = CheckoutProcessService.processOrderUpdateCoreData({
              ...props,
              requestUUID: ctrl.requestUUID,
            });
            ApiService.orders
              .update(data ? data : this.model)
              .then((response) => ctrl.success.complete(response))
              .catch((repsonse) => ctrl.error.complete(repsonse));
          }
        },

        cancel: function () {
          window.history.go(-1);
        },

        shouldUseCORSCheckout() {
          return CheckoutProcessService.shouldUseCORSCheckout({ requiresCardData: ctrl.requiresCardData });
        },

        clearLoading() {
          ctrl.isSubmitted = false;
        },

        success: {
          init: function (response) {
            var self = ctrl;
            // Check if account order or normal order for permissions
            if (response.data.payload.accountId) {
              if (!PermissionsService.check('ACCT_ORDERS_UPDATE')) {
                console.log('ACCT_ORDERS_UPDATE');
                $state.go('home.default', {}, { notify: true });
              }
              self.isAccount = true;
              self.model.accountId = response.data.payload.accountId;
              self.getPayment(response.data.payload.accountId);
            } else {
              if (!PermissionsService.check('ORDER_UPDATE')) {
                console.log('ORDER_UPDATE');
                $state.go('home.default', {}, { notify: true });
              }
            }
            self.model = self.process(response.data.payload);
            if (self.model.paymentMethodName === self.paymentMethods['2']) {
              self.paymentDetails.mappings.paymentId = 'Check Number';
            }
            self.notes = self.model.notes ? self.model.notes + '' : '';
            self.loadPendingGiftCardRedemptions(self.model.giftCardRedemptions);
            self.updateGiftCardAmountDue();
          },

          getPayment: function (response) {
            var self = ctrl;
            self.accountPaymentPolicy = response.data.payload;
            self.selectEmailOption();
          },

          complete: function (response) {
            const orderId = ctrl.model.orderId;
            ctrl.notice.showSuccessMessages([{ message: 'Successfully Saved!' }], { duration: 3000 }).then(() => {
              ctrl.resetModel();
              $state.go('application.orders.detail.summary', { orderId: orderId });
            });
          },
        },

        error: {
          init: function (response) {
            return;
          },
          getPayment: function (response) {
            return;
          },
          complete: function (response: { status: number; data: PaymentProcessError }) {
            var self = ctrl;
            self.isSubmitted = false;

            $scope.$broadcast('Payment::Process::Error', { response: response });

            const messages = response.data.errors
              ? response.data.errors.map((error) => ({ message: error.message.replace(/^.*?:/, '') }))
              : [{ message: response.data.error.replace(/^.*?:/, '') }];

            ctrl.notice.showErrorMessages(messages);
          },
        },

        onPaymentComplete: function (e, payment) {
          var self = ctrl;

          self.setEmailOption();

          var data = Object.assign({}, self.model);

          data.payment = payment;

          if (payment.contactFirstName) {
            data.payment.firstName = payment.contactFirstName;

            //ENG-5902 billing contact get overwritten visually
            self.model.contactFirstName = payment.contactFirstName;
          }

          if (payment.contactLastName) {
            data.payment.lastName = payment.contactLastName;

            self.model.contactLastName = payment.contactLastName;
          }

          if (payment.contactEmail) {
            self.model.email = payment.contactEmail;
          }

          if (payment.phoneNumber) {
            self.model.phoneNumber = payment.phoneNumber;
          }

          console.log('OrdersPaymentController::onPaymentComplete', data);
          self.complete(data);
        },
        onPaymentError: function (e, data) {
          var self = ctrl;
          self.isSubmitted = false;
          ctrl.notice.showErrorMessages([{ message: data }], { duration: 3000 });
        },
      };

      $scope.ordersPayment = ctrl;
      ctrl.init();
    },
  ]).name;
